export const primaryFriendLinks = [
  {
    url: 'http://www.izaojiao.com/',
    title: '早教'
  },
  {
    url: 'http://gaokao.xdf.cn/college/',
    title: '全国大学'
  },
  {
    url: 'http://xsc.xdf.cn/',
    title: '小升初辅导'
  },
  {
    url: 'http://xiaoxue.xdf.cn/lnj/',
    title: '六年级作文'
  },
  {
    url: 'http://xiaoxue.xdf.cn/ynj/',
    title: '一年级数学'
  },
  {
    url: 'http://souke.xdf.cn/Search?cid=1&ccc=40&gc=0&hide=0',
    title: '少儿英语'
  },
  {
    url: 'http://souke.xdf.cn/Search?cid=1&ccc=40&gc=0&hide=0&attr=17',
    title: '小学阅读写作'
  },
  {
    url: 'http://goabroad.xdf.cn/',
    title: '低领留学'
  },
  {
    url: 'http://g.beva.com/',
    title: '贝瓦儿歌'
  },
  {
    url: 'http://kids.163.com/',
    title: '网易中小学'
  },
  {
    url: 'http://www.maxen.com.cn',
    title: '小学英语培训'
  }
]



// WEBPACK FOOTER //
// ./src/api/js/primary/friendlinks.js